<template>
    <div class="error-container">
        <svgIcon icon-holder-class="nexon-logo" icon-id="nexon-logo"></svgIcon>
        <img class="error-logo" :src="errorImg" />
        <h1>{{ $t('shop.404-not-found') }}</h1>
    </div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'Error',
    components: {
        svgIcon,
    },
    props: {},
    data() {
        return {};
    },
    computed: {
        imgHost() {
            return `${process.env.BASE_URL}static/images/`;
        },
        errorImg() {
            return `${this.imgHost}logo-error.png`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="less" scoped>
.error-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    min-height: 500px;
    padding: 60px 30px 360px;
    width: 100%;
    h1 {
        color: #fff;
        margin-top: 60px;
    }
    .nexon-logo {
        height: 10px;
        width: 67px;
    }
    .error-logo {
        margin-top: 60px;
    }
}
</style>
